<div class="tfr-alerts" *ngIf="airport.tfrs && airport.tfrs.length">
  <div [ngClass]="{'tfr-alert': true, 'tfr-alert__container':true }" *ngFor="let tfr of getActiveTFRs(); let i = index">
    <div [ngClass]="{'tfr-alert': true }">
      <div class="tfr-alert__text">
        <strong *ngIf="formatTitle(tfr)">{{ formatTitle(tfr) }}</strong><br/>
        <span class="tfr-alert--description"><p style="white-space: pre-line">EFFECTIVE {{ tfr.effectiveDate | date: 'MM/dd/yyyy HHmm' }} UTC -
        <span *ngIf="tfr.expirationDate; else furtherNotice">{{ tfr.expirationDate | date: 'MM/dd/yyyy HHmm' }} UTC</span></p></span>
        <a (click)="navigateToTFRs()">View Details</a>
      </div>
    </div>
  </div>
  <div [ngClass]="{'tfr-alert': true, 'tfr-alert__container':true, 'tfr-alert--notice': true }" *ngFor="let tfr of getScheduledTFRs(); let i = index">
    <div [ngClass]="{'tfr-alert': true, 'tfr-alert--notice': true }">
      <div class="tfr-alert__text-scheduled">
        <strong *ngIf="formatTitle(tfr)">{{ formatTitle(tfr) }}</strong><br/>
        <span class="tfr-alert--description"><p style="white-space: pre-line">EFFECTIVE {{ tfr.effectiveDate | date: 'MM/dd/yyyy HHmm' }} UTC -
        <span *ngIf="tfr.expirationDate; else furtherNotice">{{ tfr.expirationDate | date: 'MM/dd/yyyy HHmm' }} UTC</span></p></span>
        <a (click)="navigateToTFRs()">View Details</a>
      </div>
    </div>
  </div>
</div>

<ng-template #furtherNotice>
  <span>FURTHER NOTICE</span>
</ng-template>
